module.exports = __webpack_public_path__ + "static/media/css.ec476ee0.png";